var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ImportJobStatus, } from '@common/api';
import { getMutationOptionsFactory } from '@util/query';
import { importJobsApi } from '@data/rest/api';
export var importJobKeys = Object.freeze({
    all: ['importJob'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(importJobKeys.all), false), ['list'], false);
    },
    list: function (filter) {
        if (filter === void 0) { filter = 'all'; }
        return __spreadArray(__spreadArray([], __read(importJobKeys.lists()), false), [filter], false);
    },
    rows: function () {
        return __spreadArray(__spreadArray([], __read(importJobKeys.all), false), ['rows'], false);
    },
    listRows: function (importJobId) {
        return __spreadArray(__spreadArray([], __read(importJobKeys.rows()), false), [importJobId], false);
    },
});
var mutationOptionsFactory = getMutationOptionsFactory();
function getImportJobs() {
    return importJobsApi.list();
}
export function useImportJobs(options) {
    return useQuery(importJobKeys.list(), getImportJobs, options);
}
function updateImportJob(data) {
    var id = data.id, updateData = __rest(data, ["id"]);
    return importJobsApi.update(id, updateData);
}
export function useUpdateImportJob() {
    var key = importJobKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('update', key, queryClient);
    return useMutation(updateImportJob, options);
}
function commitImportJob(id) {
    return importJobsApi.commit(id);
}
function getPropChangeOptions(queryKey, queryClient, prop, value) {
    return {
        mutationKey: queryKey,
        onMutate: function (resourceId) {
            return __awaiter(this, void 0, void 0, function () {
                var previousResources, updater;
                return __generator(this, function (_a) {
                    previousResources = queryClient.getQueryData(queryKey);
                    updater = function (oldResources) {
                        if (oldResources === undefined) {
                            return undefined;
                        }
                        return oldResources.map(function (resource) {
                            var _a;
                            if (resource.id === resourceId) {
                                return __assign(__assign({}, resource), (_a = {}, _a[prop] = value, _a));
                            }
                            else {
                                return resource;
                            }
                        });
                    };
                    queryClient.setQueryData(queryKey, updater);
                    return [2 /*return*/, { previousResources: previousResources }];
                });
            });
        },
        onError: function (error, resourceId, context) {
            console.error('Failed to update resource: ', resourceId, ' queryKey=', queryKey);
            queryClient.setQueryData(queryKey, context === null || context === void 0 ? void 0 : context.previousResources);
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
}
export function useCommitImportJob() {
    var key = importJobKeys.list();
    var queryClient = useQueryClient();
    var options = getPropChangeOptions(key, queryClient, 'status', ImportJobStatus.COMMITED);
    return useMutation(commitImportJob, options);
}
function revertImportJob(id) {
    return importJobsApi.revert(id);
}
export function useRevertImportJob() {
    var key = importJobKeys.list();
    var queryClient = useQueryClient();
    var options = getPropChangeOptions(key, queryClient, 'status', ImportJobStatus.REVERTED);
    return useMutation(revertImportJob, options);
}
function detectDimensions(id) {
    return importJobsApi.detectDimensions(id);
}
export function useDetectDimensions() {
    var key = importJobKeys.list();
    var queryClient = useQueryClient();
    return useMutation(detectDimensions, {
        // no optimistic update, just invalidate when finished
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(key)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function deleteImportJob(importJobId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, importJobsApi.remove(importJobId)];
        });
    });
}
export function useDeleteImportJob() {
    var key = importJobKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('delete', key, queryClient);
    return useMutation(deleteImportJob, options);
}
function getImportJobRows(importJobId) {
    return importJobsApi.getImportJobRows(importJobId);
}
export function useImportJobRows(importJobId, options) {
    return useQuery(importJobKeys.listRows(importJobId), function (context) { return getImportJobRows(context.queryKey[2]); }, options);
}
function batchUpdateImportJobRows(req) {
    return importJobsApi.batchUpdateImportJobRows(req.importJobId, { rows: req.batch });
}
export function useBatchUpdateImportJobRows(importJobId) {
    var key = importJobKeys.listRows(importJobId);
    var queryClient = useQueryClient();
    var options = {
        mutationKey: key,
        onMutate: function (updatedBatch) {
            return __awaiter(this, void 0, void 0, function () {
                var previousResources;
                return __generator(this, function (_a) {
                    previousResources = queryClient.getQueryData(key);
                    queryClient.setQueryData(key, function (oldData) {
                        if (oldData === undefined) {
                            return undefined;
                        }
                        var newRowMap = new Map(updatedBatch.map(function (row) { return [row.id, row.data]; }));
                        return oldData.map(function (oldRow) {
                            var newRowData = newRowMap.get(oldRow.id);
                            if (newRowData === undefined) {
                                return oldRow;
                            }
                            else {
                                return __assign(__assign({}, oldRow), { data: newRowData });
                            }
                        });
                    });
                    return [2 /*return*/, { previousResources: previousResources }];
                });
            });
        },
        onError: function (error, variables, context) {
            console.error('Failed to update resource: ', variables, ' queryKey=', key);
            queryClient.setQueryData(key, context === null || context === void 0 ? void 0 : context.previousResources);
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(key)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
    return useMutation(function (batch) { return batchUpdateImportJobRows({ importJobId: importJobId, batch: batch }); }, options);
}
